import React from 'react';
import ReactDOM from 'react-dom/client';
import './MainPage.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register the service worker — production only. Registering it in
// development fights with webpack's dev server / hot reload and can
// serve stale bundles while you're iterating, which is the opposite
// of what we want.
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((registration) => {
        console.log("Service Worker registered:", registration);

        // Detect a new SW version waiting to activate and let the user
        // grab it with a single reload instead of silently staying on
        // an old cached bundle forever.
        registration.addEventListener("updatefound", () => {
          const newWorker = registration.installing;
          if (!newWorker) return;
          newWorker.addEventListener("statechange", () => {
            if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
              console.log("New version available — reload to update.");
              newWorker.postMessage("SKIP_WAITING");
            }
          });
        });
      })
      .catch((error) => {
        console.error("Service Worker registration failed:", error);
      });

    // Reload once the new SW takes control, so the user actually gets
    // the fresh assets instead of a half-updated page.
    let refreshing = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });
  });
}

// Wire web-vitals to console for now so you can watch LCP/CLS/TBT
// improve locally as you make changes. Swap console.log for an
// analytics endpoint later if you want field data.
reportWebVitals(console.log);